import React from 'react'
import cn from 'classnames'

import { Container, Col } from 'react-grid-system'

import Button from 'components/Button'
import StringFormat from 'utils/StringFormat'

import CartBadge from '../CartBadge'

import './FooterCart.scss'
import { FLAGS, useFeatureFlag } from 'components/ff4j'
import { PodTiffany } from 'assets/img/cards'

const FooterCart = (props) => {
    const segregecaoEnabled = useFeatureFlag(FLAGS.SEGREGACAO_CNPJ)

    const getImage = (product) => {
        const image = StringFormat.renderTraditionalImg(+product.id)

        if (segregecaoEnabled && product.id === 700) {
            return PodTiffany
        }

        return image
    }

    return (
        <div className="footer-cart" id="footerCart">
            <Container className="footer-cart__container">
                <Col className="footer-cart__wrap" sm={12}>
                    <div className="footer-cart__wrap--cart">
                        <CartBadge
                            icon="cart--outlined"
                            footer={true}
                            badge={props.badge}
                            onClick={props.onClick}
                        />
                    </div>
                    <div className="footer-cart__wrap--card">
                        {props.products.map((product) => {
                            return (
                                <div
                                    key={product.id}
                                    className="footer-cart__wrap--card-content"
                                >
                                    <img
                                        className={cn(
                                            'footer-cart__wrap--mini-card',
                                            {
                                                'product--tudo': [
                                                    900, 700
                                                ].includes(product.id)
                                            }
                                        )}
                                        src={getImage(product)}
                                        alt="Alelo mini card"
                                    />
                                    <label className="footer-cart__wrap--description">
                                        Alelo <br />{' '}
                                        <strong>
                                            {
                                                StringFormat.nameProducts(
                                                    product.id
                                                ).split(' ')[1]
                                            }
                                        </strong>
                                    </label>
                                </div>
                            )
                        })}
                    </div>

                    <Button
                        id="cartSeeProposalFooter"
                        type="button"
                        kind="add"
                        gtmCategory="alelo:loja-virtual"
                        gtmAction="clique:barra-flutuante"
                        gtmLabel="ver-proposta"
                        onClick={() => props.validate()}
                    >
                        Ver proposta
                    </Button>
                </Col>
            </Container>
        </div>
    )
}

export default FooterCart
